export default __webpack_public_path__ + "static/media/latoken.a0a81d4c.svg";